import { BookOpenIcon, ChevronDownIcon, PhotoIcon, ShieldCheckIcon, VideoCameraIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';

import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger
} from '@/components/Ui/DropdownMenu';
import auth from '@/helpers/auth';

function Menu() {
    const [
        t,
    ] = useTranslation('pages');
    const isAdministrator = auth.isAdministrator();
    const location = useLocation();
    const isOnStockPage = location.pathname.startsWith('/stock');

    return (
        <nav className='hidden md:flex items-center gap-4 divide-x'>
            <NavLink
                className={ ({ isActive }) => {
                    return clsx({
                        'text-sm font-medium transition-colors pr-4': true,
                        'text-primary cursor-default': isActive,
                        'text-muted-foreground hover:text-foreground': !isActive,
                    });
                } }
                to='/quotes'>
                {t('Quotes')}
            </NavLink>
            <NavLink
                className={ ({ isActive }) => {
                    return clsx({
                        'text-sm font-medium transition-colors pr-4': true,
                        'text-primary cursor-default': isActive,
                        'text-muted-foreground hover:text-foreground': !isActive,
                    });
                } }
                to='/catalog'>
                {t('Products')}
            </NavLink>
            {isAdministrator && (
                <NavLink
                    className={ ({ isActive }) => {
                        return clsx({
                            'flex gap-x-1 items-center text-sm font-medium transition-colors pr-4': true,
                            'text-primary cursor-default': isActive || isOnStockPage,
                            'text-muted-foreground hover:text-foreground': !isActive && !isOnStockPage,
                        });
                    } }
                    to='/stocks'>
                    <ShieldCheckIcon className='h-3.5 w-3.5' />
                    {t('Stocks')}
                </NavLink>
            )}
            <DropdownMenu>
                <DropdownMenuTrigger className='flex items-center gap-1 text-sm font-medium text-muted-foreground hover:text-foreground transition-colors focus:outline-none cursor-pointer pr-2'>
                    {t('Media')}
                    <ChevronDownIcon className='h-4 w-4' />
                </DropdownMenuTrigger>
                <DropdownMenuContent align='start' className='w-48'>
                    <DropdownMenuItem asChild className='cursor-pointer'>
                        <NavLink className='flex items-center gap-2' to='/media/images'>
                            <PhotoIcon className='h-4 w-4' />
                            {t('Images')}
                        </NavLink>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild className='cursor-pointer'>
                        <NavLink className='flex items-center gap-2' to='/media/video'>
                            <VideoCameraIcon className='h-4 w-4' />
                            {t('Video')}
                        </NavLink>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild className='cursor-pointer'>
                        <NavLink className='flex items-center gap-2' to='/media/catalogues'>
                            <BookOpenIcon className='h-4 w-4' />
                            {t('Catalogues')}
                        </NavLink>
                    </DropdownMenuItem>
                </DropdownMenuContent>
            </DropdownMenu>
            <NavLink
                className={ ({ isActive }) => {
                    return clsx({
                        'text-sm font-medium transition-colors': true,
                        'text-primary cursor-default': isActive,
                        'text-muted-foreground hover:text-foreground': !isActive,
                    });
                } }
                to='/contact'>
                {t('Contact us')}
            </NavLink>
        </nav>

    );
}

export default React.memo(Menu);
